import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useState, createElement as _createElement } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from "../../atoms/Typography";
import colors from "../../theme/colors";
import Container from "../../atoms/Container";
import EditionHeaderItem from "./EditionHeaderItem";
import EditionContentItem, { ItemBonus, ItemPre } from "./EditionContentItem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EStoreProductDetailCompareEditions = ({
  editionHeaderList = [],
  onClickBuyEdition,
  labelButton,
  listEditionContentItem,
  titleCompareEdition,
  isShow = true,
  labelEarlyPurchase,
  labelPreOrder
}) => {
  const [showCompareEdition, setShowCompareEdition] = useState(true);
  useEffect(() => {
    let timeOut = null;
    window.addEventListener("show-compare-edition", () => {
      timeOut = setTimeout(() => {
        setShowCompareEdition(true);
      }, 300);
    });
    return () => {
      window.clearTimeout(timeOut);
      window.removeEventListener("show-compare-edition", () => {});
    };
  }, []);
  useEffect(() => {
    setShowCompareEdition(isShow);
  }, [isShow]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      paddingBottom: "24px"
    },
    className: "content-compare-edition",
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          padding: {
            xs: "0px 16px",
            md: "0px"
          },
          marginBottom: "24px"
        },
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            width: "100%",
            position: "relative",
            "&::before": {
              position: "absolute",
              content: "' '",
              width: "100%",
              left: "0px",
              top: "0px",
              borderBottom: "1px solid #C1C1C1",
              opacity: "0.5"
            }
          }
        })
      })
    }), /*#__PURE__*/_jsxs(Accordion, {
      sx: {
        boxShadow: 'none',
        minHeight: 'unset',
        margin: "0px !important",
        backgroundColor: 'transparent',
        "&:before": {
          display: "none"
        },
        '& .MuiAccordionSummary-root': {
          minHeight: 'unset',
          margin: '0px',
          padding: '0px'
        },
        '& .MuiAccordionSummary-content': {
          margin: '0px'
        },
        '& .Mui-expanded': {
          minHeight: 'unset !important',
          '& .MuiAccordionSummary-content': {
            minHeight: 'unset',
            margin: '0px'
          }
        }
      },
      defaultExpanded: false,
      expanded: showCompareEdition,
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            padding: {
              xs: "0px 16px",
              md: "0px"
            }
          },
          onClick: () => {
            setShowCompareEdition(!showCompareEdition);
          },
          children: /*#__PURE__*/_jsx(AccordionSummary, {
            expandIcon: /*#__PURE__*/_jsx(ExpandMoreIcon, {
              sx: {
                fill: colors.primary.bandaiNamcoBlack
              }
            }),
            "aria-controls": "panel1a-content",
            id: "panel1a-header",
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "h5",
              children: titleCompareEdition
            })
          })
        })
      }), /*#__PURE__*/_jsx(Container, {
        sx: {
          display: {
            xs: "none",
            md: "flex"
          },
          paddingTop: {
            xs: "40px",
            md: "46px"
          }
        },
        children: /*#__PURE__*/_jsxs(AccordionDetails, {
          sx: {
            padding: "0px",
            width: "100%"
          },
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              width: "100%",
              display: "flex",
              flexDirection: "column"
            },
            children: [/*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                width: "100%",
                gap: "16px",
                marginBottom: "10px",
                justifyContent: "space-between"
              },
              children: [/*#__PURE__*/_jsx(Box, {
                sx: {
                  flex: 1,
                  width: "314px",
                  maxWidth: "358px"
                  // minWidth: "358px",
                }
              }), /*#__PURE__*/_jsx(Box, {
                sx: {
                  flex: 1,
                  display: "flex",
                  gap: "16px",
                  justifyContent: "flex-end"
                },
                children: !!editionHeaderList?.length && editionHeaderList.map((item, index) => {
                  return /*#__PURE__*/_createElement(EditionHeaderItem, _extends({}, item, {
                    labelButton: labelButton,
                    key: index,
                    onClickBuy: onClickBuyEdition
                  }));
                })
              })]
            }), !!listEditionContentItem?.length && listEditionContentItem.map((item, index) => {
              return /*#__PURE__*/_jsx(Box, {
                sx: {
                  background: index % 2 === 0 ? colors.neutral.neutral8 : colors.primary.bandaiNamcoWhite
                },
                children: /*#__PURE__*/_jsx(EditionContentItem, _extends({}, item))
              }, index);
            })]
          }), (labelEarlyPurchase || labelPreOrder) && /*#__PURE__*/_jsxs(Box, {
            sx: {
              margin: "20px 0px",
              display: "flex",
              alignItems: "center"
            },
            children: [!!labelEarlyPurchase && /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                alignItems: "center"
              },
              children: [ItemBonus(24), /*#__PURE__*/_jsx(Typography, {
                sx: {
                  fontSize: "14px",
                  lineHeight: "19px",
                  fontWeight: 400,
                  margin: "0px 24px 0px 10px"
                },
                children: labelEarlyPurchase
              })]
            }), !!labelPreOrder && /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                alignItems: "center"
              },
              children: [ItemPre(24), /*#__PURE__*/_jsx(Typography, {
                sx: {
                  fontSize: "14px",
                  lineHeight: "19px",
                  fontWeight: 400,
                  margin: "0px 24px 0px 10px"
                },
                children: labelPreOrder
              })]
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          display: {
            xs: "flex",
            md: "none"
          },
          paddingTop: {
            xs: "40px",
            md: "48px"
          },
          width: "100%",
          overflow: "scroll",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none"
          }
        },
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            display: "flex",
            minWidth: {
              xs: editionHeaderList?.length <= 1 ? "100%" : "auto",
              md: editionHeaderList?.length <= 1 ? "100%" : "768px",
              lg: editionHeaderList?.length <= 1 ? "100%" : "auto"
            },
            padding: {
              xs: "0px 32px",
              md: "0px 48px",
              lg: "0px"
            }
          },
          children: /*#__PURE__*/_jsxs(AccordionDetails, {
            sx: {
              padding: "0px",
              width: "100%"
            },
            children: [/*#__PURE__*/_jsxs(Box, {
              sx: {
                width: "100%",
                display: "flex",
                flexDirection: "column"
              },
              children: [/*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: "flex",
                  width: "100%",
                  gap: "16px",
                  marginBottom: "10px"
                },
                children: [/*#__PURE__*/_jsx(Box, {
                  sx: {
                    flex: 1,
                    maxWidth: "140px",
                    width: "140px"
                  }
                }), /*#__PURE__*/_jsx(Box, {
                  sx: {
                    flex: 1,
                    display: "flex",
                    gap: "16px",
                    justifyContent: "flex-end"
                  },
                  children: !!editionHeaderList?.length && editionHeaderList.map((item, index) => {
                    return /*#__PURE__*/_createElement(EditionHeaderItem, _extends({}, item, {
                      labelButton: labelButton,
                      key: index,
                      onClickBuy: onClickBuyEdition
                    }));
                  })
                })]
              }), !!listEditionContentItem?.length && listEditionContentItem.map((item, index) => {
                return /*#__PURE__*/_jsx(Box, {
                  sx: {
                    width: "100%",
                    background: index % 2 === 0 ? colors.neutral.neutral8 : colors.primary.bandaiNamcoWhite
                  },
                  children: /*#__PURE__*/_jsx(EditionContentItem, _extends({}, item))
                }, index);
              })]
            }), (labelEarlyPurchase || labelPreOrder) && /*#__PURE__*/_jsxs(Box, {
              sx: {
                margin: "20px 0px",
                display: "flex",
                alignItems: "center"
              },
              children: [!!labelEarlyPurchase && /*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: "flex",
                  alignItems: "center"
                },
                children: [ItemBonus(16), /*#__PURE__*/_jsx(Typography, {
                  sx: {
                    fontSize: "14px",
                    lineHeight: "19px",
                    fontWeight: 400,
                    margin: "0px 16px 0px 8px"
                  },
                  children: labelEarlyPurchase
                })]
              }), !!labelPreOrder && /*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: "flex",
                  alignItems: "center"
                },
                children: [ItemPre(16), /*#__PURE__*/_jsx(Typography, {
                  sx: {
                    fontSize: "14px",
                    lineHeight: "19px",
                    fontWeight: 400,
                    margin: "0px 16px 0px 8px"
                  },
                  children: labelPreOrder
                })]
              })]
            })]
          })
        })
      })]
    })]
  });
};
export default EStoreProductDetailCompareEditions;